// packages/studio/web/src/repos/browser/BranchSwitcher.tsx
//
// Thin wrapper around the existing BranchPicker from P08/history.
// Adapts the prop names used in the browser context to BranchPicker's API.

import { BranchPicker } from "../../history/BranchPicker.js";

export interface BranchSwitcherProps {
  readonly wsSlug: string;
  readonly repoSlug: string;
  readonly currentRef: string;
  readonly onChange: (next: string) => void;
}

export function BranchSwitcher({ wsSlug, repoSlug, currentRef, onChange }: BranchSwitcherProps) {
  return (
    <BranchPicker
      slug={wsSlug}
      repo={repoSlug}
      value={currentRef}
      onChange={onChange}
    />
  );
}
